import m from 'mithril'
const base_image_url = 'https://libraryofshortstories.s3.ap-southeast-2.amazonaws.com/small/'


const novel_ads = {

    titles: {
        fantasy: { link: 'https://bookshop.org/a/96136/9780786852550', image: 'bookshop_samarkand' },
        'sci-fi': { link: 'https://bookshop.org/a/96136/9780345391803', image: 'bookshop_galaxy' },
        adventure: { link: 'https://bookshop.org/a/96136/9781250157935', image: 'bookshop_temple' },
        quirky: { link: 'https://bookshop.org/a/96136/9780063393233', image: 'bookshop_mort' },
        childrens: { link: 'https://bookshop.org/a/96136/9780394820378', image: 'bookshop_phantom' },
        tragedy: { link: 'https://bookshop.org/a/96136/9781101934180', image: 'bookshop_thief' },
        mystery: { link: 'https://bookshop.org/a/96136/9780064407663', image: 'bookshop_unfortunate' },
    },

    base: {
        view: vnode => {
            return m('a.bookshop_link.remove_default_link_styling',
                {
                    href: vnode.attrs.link,
                    rel: 'sponsored'
                },
                m('.image_section',
                    m('img', { src: base_image_url + vnode.attrs.image + '.jpg' }),
                ),
                vnode.children,
                m('.buy_now', 'Buy Now!')
            )
        }
    },

    fantasy: {
        view: vnode => {
            return m(novel_ads.base, novel_ads.titles.fantasy, m('.text', 'If you are a fan of fantasy then the Library of Short Stories recommends the novel ', m('i.sponsor_link', 'The Amulet of Samarkand by Jonathan Stroud'), ' as a beautifully imaginative adventure into the land of djinni and magicians.'))
        }
    },

    scifi: {
        view: vnode => {
            return m(novel_ads.base, novel_ads.titles['sci-fi'], m('.text', 'If you are a fan of science fiction then the Library of Short Stories recommends the novel ', m('i.sponsor_link', 'The Hitchhiker’s Guide to the Galaxy by Douglas Adams'), ' as a comedic investigation of absurd worlds, aliens and technologies.'))
        }
    },
    adventure: {
        view: vnode => {
            return m(novel_ads.base, novel_ads.titles.adventure, m('.text', 'If you are a fan of adventure then the Library of Short Stories recommends the novel ', m('i.sponsor_link', 'The Temple by Matthew Reilly'), ' as an unrestrained and explosive journey into ancient pasts and military conspiracies.'))
        }
    },
    quirky: {
        view: vnode => {
            return m(novel_ads.base, novel_ads.titles.quirky, m('.text', 'If you are looking for a humorous novel then the Library of Short Stories recommends ', m('i.sponsor_link', 'Mort by Terry Pratchett'), ' as a delightful and satirical adventure of a job-searching boy who becomes apprenticed to Death himself.'))
        }
    },
    childrens: {
        view: vnode => {
            return m(novel_ads.base, novel_ads.titles.childrens, m('.text', 'If you are a looking for an imaginative book for children then the Library of Short Stories recommends the novel ', m('i.sponsor_link', 'The Phantom Tollbooth by Norton Juster'), ' as a fun and inspiring tale of a magical land of dogs with clocks on their backs, word-stealing witches and half-children.'))

        }
    },
    tragedy: {
        view: vnode => {
            return m(novel_ads.base, novel_ads.titles.tragedy, m('.text', 'If you are looking for deeply human novels then the Library of Short Stories recommends ', m('i.sponsor_link', 'The Book Thief by Markus Zusak'), ' as a thought-provoking and soulful story of an adopted child’s painful search for meaning in Nazi Germany.'))
        }
    },

    mystery: {
        view: vnode => {
            return m(novel_ads.base, novel_ads.titles.mystery,m('.text', 'If you are looking for a mystery novel then the Library of Short Stories recommends ', m('i.sponsor_link', 'A Series of Unfortunate Events by Lemony Snicket'), ', the sad but soulful trials of the Baudelaire children at the hands of the trickster Count Olaf.'))
        }

    },

    select_one: {
        view: vnode => {
            switch (vnode.attrs.genre) {
                case 'sci-fi':
                    return m(novel_ads.scifi)
                case 'fantasy':
                    return m(novel_ads.fantasy)
                case 'adventure':
                    return m(novel_ads.adventure)
                case 'childrens':
                    return m(novel_ads.childrens)
                case 'tragedy':
                    return m(novel_ads.tragedy)
                case 'quirky':
                    return m(novel_ads.quirky)
                case 'mystery':
                    return m(novel_ads.mystery)
                default:
                    return m(full_kofi_link)
            }
        }
    }
}



const full_kofi_link = {
    view: vnode => {
        return m("a.kofi_link.has_physical_box", {
            "href": "https://ko-fi.com/evanclewis",
            "title": "Support me on Ko-fi",
        },
            m('img.kofi_image',
                {
                    src: base_image_url + 'kofi_bg_tag_white.png',
                    alt: "A link saying 'Support me on Ko-Fi'"
                }
            ),
            m('', 'Any donation will help keep the library running with regular updates of new stories and collections.')

        )
    }
}

export default novel_ads